import { HttpEvent, HttpEventType } from '@angular/common/http';
import { ComponenteModel } from 'app/model/endereco/componente.model';
import { TipoCaixaModel } from './../../../../model/caixa/tipocaixa.model';
import { TipoComponenteModel } from './../../../../model/endereco/tipocomponente.mode';
import { UnidadeModel } from './../../../../model/endereco/unidade.model';
import { TipoComponenteService } from './../../../../service/endereco/tipo-componente.service';
import { UnidadeService } from './../../../../service/endereco/unidade.service';
import { TipoCaixaService } from './../../../../service/caixa/tipo-caixa.service';
import { ModuloModel } from './../../../../model/endereco/modulo.model';
import { ModuloService } from './../../../../service/endereco/modulo.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ComponenteService } from './../../../../service/endereco/componente.service';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-adicionar-componente',
  templateUrl: './adicionar-componente.component.html',
  styleUrls: ['./adicionar-componente.component.scss']
})
export class AdicionarComponenteComponent implements OnInit {

  @ViewChild('gerarComponenteButton') gerarComponenteButton: ElementRef;
  @ViewChild('cancelarComponenteButton') cancelarComponenteButton: ElementRef;
  public componenteForm: FormGroup;
  public componente = {} as ComponenteModel;
  public loading = false;
  public submit = false;
  public modulos: ModuloModel[];
  public unidades: UnidadeModel[];
  public tiposComponentes: TipoComponenteModel[];
  public tiposRecipientes: TipoCaixaModel[];
  public horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  public verticalPosition: MatSnackBarVerticalPosition = 'top';
  public progress = 0;
  public progressBar = false;
  public hiddenForm = false;
  public moduloId;
  public selectModulo = true;
  public showQtds =  false;
  public qtdHorizontal = new FormControl();
  public qtdVertical = new FormControl();
  public qtdProfundidade = new FormControl();
  public inputValueQtdHorizontal;
  public inputValueQtdVertical;
  public inputValueQtdProfundidade;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<AdicionarComponenteComponent>,
    private componenteService: ComponenteService,
    private moduloService: ModuloService,
    private tipoCaixaService: TipoCaixaService,
    private unidadeService: UnidadeService,
    private tipoComponenteService: TipoComponenteService,
    private fb: FormBuilder,
    private _snackBar: MatSnackBar) {
      if (data !== null) {
        this.moduloId = data.modulo;
        console.log(data);
      }
     }

  ngOnInit() {
    this.createForm();
    this.getModulos();
    this.getUnidades();
    this.getTipoRecipientes();
    this.getTipoComponentes();
  }

  gerarComponente() {
    this.gerarComponenteButton.nativeElement.click();
  }

  cancelarComponente() {
    this.cancelarComponenteButton.nativeElement.click();
  }

  createForm() {
    this.componenteForm = this.fb.group({
      nome: [null, Validators.required],
      ativo: [null],
      isAlocacaoRecipiente: [null],
      paridade: [null, Validators.required], //Valor inteiro -> 0 === PAR and 1 === IMPAR
      ordenacao: [null, Validators.required],
      isPai: [null],
      componentesFilhos: [null],
      cor: [null, Validators.required],
      altura: [null, Validators.required],
      largura: [null, Validators.required],
      profundidade: [null, Validators.required],
      posicaoHorizontal: [null, Validators.required],
      posicaoVertical: [null, Validators.required],
      componentePai: [null],
      modulo: [null, Validators.required],
      tipoCaixa: [null],
      tipoComponente: [null, Validators.required],
      unidade: [null, Validators.required]
    });
  }

  onChange() {
    const moduloSelecionado = (this.componenteForm.get('modulo').value);
    console.log(moduloSelecionado.id);
    this.componenteForm.get('altura').setValue(moduloSelecionado.alturaComponente);
    this.componenteForm.get('largura').setValue(moduloSelecionado.larguraComponente);
    this.componenteForm.get('profundidade').setValue(moduloSelecionado.profundidadeComponente);
    if (moduloSelecionado.id === undefined) {
      this.hiddenForm = false;
    } else {
      this.hiddenForm = true;
    }
  }

  getModulos() {
    this.loading = true;
    this.moduloService.getModulosList().subscribe(data => {
      this.modulos = data;
      this.loading = false;
      if (this.moduloId !== null) {
        this.modulos.map(element => {
          if (element.id === this.moduloId) {
            let modulo: any = element;
            this.componenteForm.get('modulo').setValue(modulo);
            this.componenteForm.get('altura').setValue(modulo.alturaComponente);
            this.componenteForm.get('largura').setValue(modulo.larguraComponente);
            this.componenteForm.get('profundidade').setValue(modulo.profundidadeComponente);
            this.hiddenForm = true;
            this.selectModulo = false;
          }
        });
      }
    }, err => {
      console.error(err);
    });
  }

  getUnidades() {
    this.loading = true;
    this.unidadeService.getUnidades().subscribe(data => {
      this.unidades = data;
      this.loading = false;
    }, err => {
      console.error(err);
    });
  }

  getTipoComponentes() {
    this.loading = true;
    this.tipoComponenteService.getTipoComponentes().subscribe(data => {
      this.tiposComponentes = data;
      this.loading = false;
    }, err => {
      console.error(err);
    });
  }

  getTipoRecipientes() {
    this.loading = true;
    this.tipoCaixaService.getTipoCaixasUsuario().subscribe(data => {
      this.tiposRecipientes = data;
    }, err => {
      console.error(err);
    });
  }

  onSubmit() {
    this.submit = true;
    this.adicionarComponente();
  }

  checkValue(event: any) {
    if (event.currentTarget.checked === true) {
      this.showQtds =  true;
    } else {
      this.showQtds =  false;
    }
 }

 checkCampoNull() {
  this.inputValueQtdHorizontal = this.qtdHorizontal.value;
  this.inputValueQtdVertical = this.qtdVertical.value;
  this.inputValueQtdProfundidade = this.qtdProfundidade.value;
  console.log(this.inputValueQtdHorizontal);
  console.log(this.inputValueQtdVertical);
  console.log(this.inputValueQtdProfundidade);
  if ((this.inputValueQtdHorizontal === null) || (this.inputValueQtdHorizontal === '') || (this.inputValueQtdHorizontal === undefined)) {
    this.inputValueQtdHorizontal = 0;
  }
  if ((this.inputValueQtdVertical === null) || (this.inputValueQtdVertical === '') || (this.inputValueQtdVertical === undefined)) {
    this.inputValueQtdVertical = 0;
  }
  if ((this.inputValueQtdProfundidade === null) || (this.inputValueQtdProfundidade === '') || (this.inputValueQtdProfundidade === undefined)) {
    this.inputValueQtdProfundidade = 0;
  }
 }

  adicionarComponente() {
    this.checkCampoNull();
    const isAlocacao = this.componenteForm.get('isAlocacaoRecipiente').value;
    if (isAlocacao === null || isAlocacao === undefined) {
      this.componenteForm.get('isAlocacaoRecipiente').setValue(false);
    }
    this.progressBar = true;
    this.componenteService.adicionarComponente(this.componenteForm.value, this.inputValueQtdHorizontal , this.inputValueQtdVertical, this.inputValueQtdProfundidade).subscribe(data => {
      console.log(data);
      this.openSnackBarSuccess('Registros dos componentes foram criados com sucesso !');
      this.progressBar = false;
    }, err => {
      console.error(err);
      this.openSnackBarError('Erro ! ' + err.error.message);
      this.progressBar = false;
    });
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/endereco-components/componente/adicionar-componente/adicionar-componente.component.ts